import { render, staticRenderFns } from "./Scorecard.vue?vue&type=template&id=4210e9b4&scoped=true&"
import script from "./Scorecard.vue?vue&type=script&lang=js&"
export * from "./Scorecard.vue?vue&type=script&lang=js&"
import style0 from "./Scorecard.vue?vue&type=style&index=0&id=4210e9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210e9b4",
  null
  
)

export default component.exports